import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'DrawerMenu' })((theme) => ({
    root: {
        padding: 8,
        borderRadius: 8,
        color: '#fff',
        background: '#2D2D2D !important'
    },
    paper: {
        position: 'relative',
        paddingTop: 64,
        background: isLightMode(theme) ? '#fff' : '#17161B',
        boxSizing: 'border-box',
        width: '100vw',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    navigation: {
        gap: 24,
        marginTop: 16
    },
    buttons: {
        position: 'sticky',
        bottom: 0,
        padding: 16,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12
    }
}));
